import Table from '@/common/components/Table';
import { BillingTransactionIdentifier } from '@/common/types/billing/transactionIdentifier.type';
import { CardDetailsData } from '@/common/types/cards/details.type';
import EquipmentInfo from '@/features/consumption/components/EquipmentInfo';
import refundTableColumnsContant from '../constants/refundTableColumns.contant';
import { BillingTransactionIdentifiersTransformer } from '../services/billingTransactionIdentifiersTransformer';
import { cn } from '@/common/utils/cn';
import { isMobile } from 'react-device-detect';

interface TransactionInformationProps {
  transactionIdentifiers: BillingTransactionIdentifier;
  transactionIdentifiersIsPending: boolean;
}

export const TransactionInformation = ({ transactionIdentifiers, transactionIdentifiersIsPending }: TransactionInformationProps) => {
  return (
    <div className="flex flex-col gap-6 sm:max-h-[440px] overflow-y-auto sm:pe-2">
      <div className="w-full space-y-4">
        {transactionIdentifiers?.eventable?.card && (
          <EquipmentInfo
            companyFantasyName={transactionIdentifiers.eventable.presented_client_fantasy_name}
            companyBranchDisplayName={transactionIdentifiers.eventable.client_branch.display_name}
            cardDetails={transactionIdentifiers?.eventable?.card as unknown as CardDetailsData}
          />
        )}
      </div>

      <Table
        className='sm:min-h-[200px]'
        columns={refundTableColumnsContant}
        isLoadingData={transactionIdentifiersIsPending}
        rows={BillingTransactionIdentifiersTransformer.tableTransformer()(
          transactionIdentifiers.eventable?.line_items || [],
        )}
        page={1}
        totalPages={1}
        footerClassName={cn(isMobile && "rounded-none")}
        flatHeader={isMobile}
      />
    </div>
  );
};
